import { UserListResponse } from '@/generated'
import { IUserTable } from './user-interface'
import {
  getUserRoleByUseraccesslevel,
  getUserStatusByActivation,
} from './user-const'

export const userResponseDTO = (values: UserListResponse): IUserTable => {
  return {
    items: values.items.map((item) => ({
      id: item.useruuid,
      firstName: item.firstname,
      lastName: item.lastname,
      createdAt: item.created_at ?? '',
      invitationValid: item.invitation_valid,
      status: getUserStatusByActivation(item.activation),
      email: item.email,
      lastestLogin: item.last_login_date,
      role: getUserRoleByUseraccesslevel(item.useraccesslevel),
    })),
    total: values.total,
    activatedTotal: values.activation_counts.activated,
    pendingTotal: values.activation_counts.invited,
    deactivatedTotal: values.activation_counts.deactivated,
  }
}
